import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import customTheme from './theme/customTheme';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Categorias from './pages/Categorias';
import CotizacionPage from './pages/Cotizacion';
import NotaVentaPage from './pages/NotaVenta';
import FacturaPage from './pages/Factura';
import BoletaVentaPage from './pages/BoletaVenta';
import NotaCreditoPage from './pages/NotaCredito';
import NotadebitoPage from './pages/NotaDebito';
import GuiaRemisionPage from './pages/GuiaRemision';
import GuiaRemisionTransportistaPage from './pages/GuiaRemisionTransportista';
import AdminEmpresas from './pages/Admin';
import CompraPage from './pages/Compra';
import NotaCreditoCompraPage from './pages/NotaCreditoCompra';
import KardexPage from './pages/Kardex';
import TesoreriaPage from './pages/Tesoreria';
import CajaChicaPage from './pages/CajaChica';
import ManualPage from './pages/Manual';
import RequerimientoPage from './pages/Requerimiento';
import OrdenCompraPage from './pages/OrdenCompra';
import EmpresasContables from './pages/contabilidad/EmpresasContables';
import PlanContable from './pages/contabilidad/PlanContable';
import Periodos from './pages/contabilidad/Periodos';
import { EmpresaContableProvider } from './context/EmpresaContableContext';

const ENABLE_ADMIN = process.env.REACT_APP_ENABLE_ADMIN === 'true';

function App() {
  const [token, setToken] = React.useState(localStorage.getItem('token'));

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
    <ThemeProvider theme={customTheme}>
      <EmpresaContableProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login setToken={setToken} />} />
          <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/categorias" element={token ? <Categorias /> : <Navigate to="/login" />} />
          <Route path="/cotizaciones" element={token ? <CotizacionPage /> : <Navigate to="/login" />} />
          <Route path="/nota-venta" element={token ? <NotaVentaPage /> : <Navigate to="/login" />} />
          <Route path="/factura" element={token ? <FacturaPage /> : <Navigate to="/login" />} />
          <Route path="/boleta" element={token ? <BoletaVentaPage /> : <Navigate to="/login" />} />
          <Route path="/nota-credito" element={token ? <NotaCreditoPage /> : <Navigate to="/login" />} />
          <Route path="/nota-debito" element={token ? <NotadebitoPage /> : <Navigate to="/login" />} />
          <Route path="/guia-remision" element={token ? <GuiaRemisionPage /> : <Navigate to="/login" />} />
          <Route path="/guia-remision-transportista" element={token ? <GuiaRemisionTransportistaPage /> : <Navigate to="/login" />} />
          <Route path="/requerimiento" element={token ? <RequerimientoPage /> : <Navigate to="/login" />} />
          <Route path="/orden-compra" element={token ? <OrdenCompraPage /> : <Navigate to="/login" />} />
          <Route path="/compras" element={token ? <CompraPage /> : <Navigate to="/login" />} />
          <Route path="/nota-credito-compra" element={token ? <NotaCreditoCompraPage /> : <Navigate to="/login" />} />
          <Route path="/kardex" element={token ? <KardexPage /> : <Navigate to="/login" />} />
          <Route path="/tesoreria" element={token ? <TesoreriaPage /> : <Navigate to="/login" />} />
          <Route path="/caja-chica" element={token ? <CajaChicaPage /> : <Navigate to="/login" />} />
          <Route path="/manual" element={token ? <ManualPage /> : <Navigate to="/login" />} />
          <Route path="/contabilidad/empresas" element={token ? <EmpresasContables /> : <Navigate to="/login" />} />
          <Route path="/contabilidad/plan" element={token ? <PlanContable /> : <Navigate to="/login" />} />
          <Route path="/contabilidad/periodos" element={token ? <Periodos /> : <Navigate to="/login" />} />
          {ENABLE_ADMIN && (
            <Route path="/admin" element={token ? <AdminEmpresas /> : <Navigate to="/login" />} />
          )}
          <Route path="/" element={<Navigate to={token ? "/dashboard" : "/login"} />} />
          <Route path="*" element={<Navigate to={token ? "/dashboard" : "/login"} />} />
        </Routes>
      </Router>
      </EmpresaContableProvider>
    </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
